// Stub: primary menu (Create with AI, 3D Models, ...) for the redesigned navigation. Implemented in a later phase.
function Menu() {
  return null
}

export default Menu
